import api from "@/api";

const state = {
    list: [],
};

const getters = {
    list(state) {
        return state.list;
    },
};

const actions = {
    findByName({ commit }, { query, sort = "active" }) {
        return api.get(`/api/goals/tags/list/${sort}`).then(res => {
            const list = res.data || [];
            commit("updateList", {
                list: query
                    ? list.filter(tag => tag.name.toLowerCase().includes(query.toLowerCase()))
                    : list,
            });
        });
    },
    reset({ commit }) {
        commit("updateList", { list: [] });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
